import React from "react";
import { Box, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CenterLayout from "../components/CenterLayout";

const festivalPages = [
    { name: "Program", url: "/festival/program", external: false },
    { name: "Bar", url: "/festival/bar", external: false },
    { name: "Kart", url: "/festival/kart", external: false },
    {
        name: "Shotterud",
        url: "https://NikolaiDokken.github.io/Shotterud",
        external: true,
    },
];

export default function Festival() {
    const navigate = useNavigate();
    return (
        <Box>
            <CenterLayout additionalSx={{ mb: 2 }}>
                <h2 style={{ marginTop: 32, marginBottom: 32 }}>Velkommen til gards!</h2>
                <Grid container spacing={2} sx={{ mb: 6 }}>
                    {festivalPages.map((page, index) => (
                        <Grid key={index} item xs={12} sm={6}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                fullWidth
                                onClick={() => (page.external ? (window.location.href = page.url) : navigate(page.url))}
                            >
                                {page.name}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
                <iframe
                    style={{
                        height: 600,
                    }}
                    width={"100%"}
                    src="https://www.youtube.com/embed/42Ht1vdWkEE?autoplay=0&controls=0&loop=1&modestbranding=1&playsinline=1&rel=0"
                    title="Aftermovie 2022"
                    frameBorder="0"
                ></iframe>
                <iframe
                    style={{
                        height: 600,
                    }}
                    width={"100%"}
                    src="https://www.youtube.com/embed/Opxl_XGgQyg?autoplay=0&controls=0&loop=1&modestbranding=1&playsinline=1&rel=0&start=125"
                    title="Aftermovie 2021"
                    frameBorder="0"
                ></iframe>
            </CenterLayout>
        </Box>
    );
}
